import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'interpolate',
  standalone: true
})
export class InterpolatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return this.interpolate(value);
  }

  interpolate(string) {
    return string
      .replace(/(<([^>]+)>)/gi, ' ')
      .replace(/&quot;/g, '"')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&#39;/g, `'`)
      .replace(/&lt;/g, '<')
      .replace(/&#x3D;/g, '=')
      .replace(/&#x60;/g, '`')
      .replace(/&#x2F;/g, '/')
      .replace(/&gt;/g, '>');
  }
}
